module.exports = __webpack_public_path__ + "img/WhyUsParrlax2.a1737aaa.png";